module.exports = __webpack_public_path__ + "static/img/zongji1.3f1a3c21.png";